// extracted by mini-css-extract-plugin
module.exports = {"aside-contacts":"_02712f2b3b--aside-contacts--BikdA"};